import { ArchReinforcement, DensityReduction, FirstRayCutout, Flanges, ForefootPosting, HeelLift, InsolesPrescriptionResponse, KirbySkive, MetatarsalPad, MortonsExtension, RearfootPosting } from "src/app/models/formResponse.model";
import { ArchReinforcementType, DesignEngineInsoles, HeelPostType, MetatarsalPadType, MortonsExtensionRigidity } from "../design-engine/interfaces/DesignEngineInsoles";

export interface ArchSettings {
    proximalStartOffset: number;
    height: number;
    apexPosition: number;
    archShape: number;
}

export interface EmbossedTextSettings {
    text: string;
    fontSize: number;
    referencePointU: number;
    referencePointV: number;
}

export interface EmbossSettings {
    embossedText: EmbossedTextSettings;
    embossedLogo: boolean;
    embossRotation: number;
    embossDepth: number;
}

// Arch es medial y lateralArch es lateral
export interface FootSettings {
    arch: ArchSettings;
    lateralArch: ArchSettings;
    emboss: EmbossSettings;
}

export interface DefaultValues {
    left: FootSettings;
    right: FootSettings;
}


export function toLeopoloyDesignEngine(
    question: InsolesPrescriptionResponse,
    engravedLogo: boolean,
    defaultValues?: DefaultValues,
    shellType?: 'thin' | 'thick',
    lengthType?: '3-4' | 'sulcus' | 'full',
    thinThickness?: number
) {
    let insoleParametersData: DesignEngineInsoles = {
        left: {
            version: 3,
            arch: {
                apexPosition: defaultValues?.left.arch.apexPosition ?? null,
                archShape: defaultValues?.left.arch.archShape,
                height: defaultValues?.left.arch.height,
                proximalStartOffset: defaultValues?.left.arch.proximalStartOffset
            },
            lateralArch: {
                apexPosition: defaultValues?.left.lateralArch.apexPosition,
                archShape: defaultValues?.left.lateralArch.archShape,
                height: defaultValues?.left.lateralArch.height,
                proximalStartOffset: defaultValues?.left.lateralArch.proximalStartOffset
            },
            emboss: {
                embossedText: {
                    text: defaultValues?.left.emboss.embossedText.text ? defaultValues?.left.emboss.embossedText.text : ""
                },
                embossedLogo: engravedLogo
            }
        },
        right: {
            version: 3,
            arch: {
                apexPosition: defaultValues?.right.arch.apexPosition,
                archShape: defaultValues?.right.arch.archShape,
                height: defaultValues?.right.arch.height,
                proximalStartOffset: defaultValues?.right.arch.proximalStartOffset
            },
            lateralArch: {
                apexPosition: defaultValues?.right.lateralArch.apexPosition,
                archShape: defaultValues?.right.lateralArch.archShape,
                height: defaultValues?.right.lateralArch.height,
                proximalStartOffset: defaultValues?.right.lateralArch.proximalStartOffset
            },
            emboss: {
                embossedText: {
                    text: defaultValues?.right.emboss.embossedText.text ? defaultValues?.right.emboss.embossedText.text : ""
                },
                embossedLogo: engravedLogo
            }
        }
    };

    // Add shell type selection (thick or thin)
    if (shellType === 'thick') {
        insoleParametersData.left.thickInsole = {
            middlePos: 0.6000000238418579,
            heelUnderCut: 0.699999988079071,
            medialUnderCut: 1.5,
            lateralUnderCut: 0.699999988079071,
            enableZones: false
        };
        insoleParametersData.right.thickInsole = {
            middlePos: 0.6000000238418579,
            heelUnderCut: 0.699999988079071,
            medialUnderCut: 1.5,
            lateralUnderCut: 0.699999988079071,
            enableZones: false
        };
    } else if (shellType === 'thin') { // thin en vez de hard
        insoleParametersData.left.thickInsole = null
        insoleParametersData.right.thickInsole = null
    }

    // Add length type selection
    if (lengthType === '3-4') {
        insoleParametersData.left.sulcus = null
        insoleParametersData.right.sulcus = null
        insoleParametersData.left.leoSulcus = null
        insoleParametersData.right.leoSulcus = null
    } else if (lengthType === 'sulcus') {
        insoleParametersData.left.sulcus = {
            type: "sulcus",
            reversed: false,
            rigidity: "rigid",
            shoeWidth: "regular"
        }
        insoleParametersData.right.sulcus = {
            type: "sulcus",
            reversed: false,
            rigidity: "rigid",
            shoeWidth: "regular"
        }
        insoleParametersData.left.leoSulcus = {
            medialLength: 1,
            lateralLength: 0,
        }
        insoleParametersData.right.leoSulcus = {
            medialLength: 1,
            lateralLength: 0,
        }
    } else if (lengthType === 'full') {
        insoleParametersData.left.sulcus = {
            type: "full",
            reversed: false,
            rigidity: "rigid",
            shoeWidth: "regular"
        }
        insoleParametersData.right.sulcus = {
            type: "full",
            reversed: false,
            rigidity: "rigid",
            shoeWidth: "regular"
        }

        // Reseteamos las otras opciones
        insoleParametersData.left.leoSulcus = null
        insoleParametersData.right.leoSulcus = null
    }

    if (thinThickness) {
        insoleParametersData.left.shell = {
            thickness: thinThickness / 10
        };

        insoleParametersData.right.shell = {
            thickness: thinThickness / 10
        };
    }


    console.log("question in mapper: ", question)

    question.components.map((insoleComponent) => {
        if (insoleComponent.type === "heelCup") {
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.heelSeat = { height: insoleComponent.left.value / 10 };
            }

            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.heelSeat = { height: insoleComponent.right.value / 10 };
            }
        }

        if (insoleComponent.type === "densityReduction") {
            insoleComponent = insoleComponent as DensityReduction

            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.reduction = {
                    heel: insoleComponent.left.position.heel,
                    medialArch: insoleComponent.left.position.medialArch,
                    lateralArch: insoleComponent.left.position.lateralArch,
                    metatarsal: insoleComponent.left.position.metatarsal,
                }
            }

            //Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.reduction = {
                    heel: insoleComponent.right.position.heel,
                    medialArch: insoleComponent.right.position.medialArch,
                    lateralArch: insoleComponent.right.position.lateralArch,
                    metatarsal: insoleComponent.right.position.metatarsal,
                }
            }
        }

        if (insoleComponent.type === "firstRayCutout") {
            console.log("Entro")
            const valueMapper = {
                mpj1: "mpj",
                firstRay: "ray"
            }

            insoleComponent = insoleComponent as FirstRayCutout
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.firstMetaCutout = {
                    type: valueMapper[insoleComponent.left.value] as unknown as string
                }
            }

            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.firstMetaCutout = {
                    type: valueMapper[insoleComponent.right.value] as unknown as string
                }
            }
        }

        if (insoleComponent.type === "fascialGroove") {

            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.fascialGroove = {
                    height: 0.3 //3mm
                }
            }

            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.fascialGroove = {
                    height: 0.3 //3mm
                }
            }
        }

        if (insoleComponent.type === "flanges") {
            insoleComponent = insoleComponent as Flanges
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.medialFlange = {
                    width: insoleComponent.left.medial.width.value / 10,
                    height: insoleComponent.left.medial.height.value / 10
                }
                insoleParametersData.left.lateralFlange = {
                    width: insoleComponent.left.lateral.width.value / 10,
                    height: insoleComponent.left.lateral.height.value / 10
                }
            }

            // Righ foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.medialFlange = {
                    width: insoleComponent.right.medial.width.value / 10,
                    height: insoleComponent.right.medial.height.value / 10
                }
                insoleParametersData.right.lateralFlange = {
                    width: insoleComponent.right.lateral.width.value / 10,
                    height: insoleComponent.right.lateral.height.value / 10
                }
            }
        }

        if (insoleComponent.type === "forefootPosting") {
            insoleComponent = insoleComponent as ForefootPosting

            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                // If it's medial it's positive number, if it's lateral it's negative
                insoleParametersData.left.forefootPost = {
                    angle: insoleComponent.left.medial ? insoleComponent.left.medial.value : -insoleComponent.left.lateral.value,
                    meshEnabled: insoleComponent.left.medial.filled ? true : false,
                    balanceToRearfoot: insoleComponent.left.medial ? insoleComponent.left.medial.balancedToRearfoot : insoleComponent.left.lateral.balancedToRearfoot
                }
            }

            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                // If it's medial it's positive number, if it's lateral it's negative
                insoleParametersData.right.forefootPost = {
                    angle: insoleComponent.right.medial ? insoleComponent.right.medial.value : -insoleComponent.right.lateral.value,
                    meshEnabled: insoleComponent.right.medial.filled ? true : false,
                    balanceToRearfoot: insoleComponent.right.medial ? insoleComponent.right.medial.balancedToRearfoot : insoleComponent.right.lateral.balancedToRearfoot
                }
            }
        }

        if (insoleComponent.type === "styloid") {
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.styloid = { height: insoleComponent.left.value / 10 };
            }
            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.styloid = { height: insoleComponent.right.value / 10 }
            }
        }

        if (insoleComponent.type === "archReinforcement") {
            insoleComponent = insoleComponent as ArchReinforcement
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.archReinforcement = {
                    type: insoleComponent.left.type as ArchReinforcementType,
                    thickness: insoleComponent.left.value / 10
                }
            }
            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.archReinforcement = {
                    type: insoleComponent.right.type as ArchReinforcementType,
                    thickness: insoleComponent.right.value / 10
                }
            }
        }

        if (insoleComponent.type === "mortonsExtension") {
            insoleComponent = insoleComponent as MortonsExtension;

            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.mortonsExtension = {
                    isReverse: insoleComponent.left.reversed,
                    rigidity: insoleComponent.left.rigidity as MortonsExtensionRigidity,
                    widthPercent: 30,
                    lengthPercent: 50,
                    lateralEdgeAngle: 0,
                    medialEdgeAngle: 0,
                    thickness: 0.11999999731779099
                }
            }
            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.mortonsExtension = {
                    isReverse: insoleComponent.right.reversed,
                    rigidity: insoleComponent.right.rigidity as MortonsExtensionRigidity,
                    widthPercent: 30,
                    lengthPercent: 50,
                    lateralEdgeAngle: 0,
                    medialEdgeAngle: 0,
                    thickness: 0.11999999731779099
                }
            }
        }

        if (insoleComponent.type === "cutout") {
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.cutout = {
                    shapes: [
                        {
                            shape: "ellipse"
                        }
                    ]
                }
            }
            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.cutout = {
                    shapes: [
                        {
                            shape: "ellipse"
                        }
                    ]
                }
            }
        }

        if (insoleComponent.type === "kirbySkive") {
            insoleComponent = insoleComponent as KirbySkive
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.kirbySkive = {
                    isMedial: insoleComponent.left.medial ? true : false,
                    depth: insoleComponent.left.medial ? insoleComponent.left.medial.value / 10 : insoleComponent.left.lateral.value / 10
                }
            }
            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.kirbySkive = {
                    isMedial: insoleComponent.right.medial ? true : false,
                    depth: insoleComponent.right.medial ? insoleComponent.right.medial.value / 10 : insoleComponent.right.lateral.value / 10
                }
            }
        }

        if (insoleComponent.type === "metatarsalPad") {
            insoleComponent = insoleComponent as MetatarsalPad
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.metatarsalPad = {
                    type: insoleComponent.left.type as MetatarsalPadType,
                    height: insoleComponent.left.value / 10
                }
            }
            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.metatarsalPad = {
                    type: insoleComponent.right.type as MetatarsalPadType,
                    height: insoleComponent.right.value / 10
                }
            }
        }

        if (insoleComponent.type === "navicularDepression") {
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                insoleParametersData.left.navicularDepression = {
                    height: insoleComponent.left.value / 10
                }
            }
            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                insoleParametersData.right.navicularDepression = {
                    height: insoleComponent.right.value / 10
                }
            }
        }

        if (insoleComponent.type === "heelLift") {
            insoleComponent = insoleComponent as HeelLift
            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                if (insoleParametersData.left.heelPost) {
                    insoleParametersData.left.heelPost.extrinsic = shellType === 'thick' ? false : true;
                    insoleParametersData.left.heelPost.heelLift = insoleComponent.left.value / 10;
                    if (shellType !== 'thick') {
                        insoleParametersData.left.heelPost.type = insoleComponent.left.type as HeelPostType;
                    }
                } else {
                    insoleParametersData.left.heelPost = {
                        extrinsic: shellType === 'thick' ? false : true,
                        heelLift: insoleComponent.left.value / 10,
                        ...(shellType !== 'thick' && { type: insoleComponent.left.type as HeelPostType })
                    }
                }

            }

            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {
                if (insoleParametersData.right.heelPost) {
                    insoleParametersData.right.heelPost.extrinsic = shellType === 'thick' ? false : true;
                    insoleParametersData.right.heelPost.heelLift = insoleComponent.right.value / 10;
                    if (shellType !== 'thick') {
                        insoleParametersData.right.heelPost.type = insoleComponent.right.type as HeelPostType;
                    }
                } else {
                    insoleParametersData.right.heelPost = {
                        extrinsic: shellType === 'thick' ? false : true,
                        heelLift: insoleComponent.right.value / 10,
                        ...(shellType !== 'thick' && { type: insoleComponent.right.type as HeelPostType })
                    }
                }

            }
        }

        if (insoleComponent.type === "rearfootPosting") {
            insoleComponent = insoleComponent as RearfootPosting;

            // Left foot
            if (insoleComponent.footSelection === "left" || insoleComponent.footSelection === "both") {
                if (insoleParametersData.left.heelPost) {
                    insoleParametersData.left.heelPost.angle = insoleComponent.left.medial ? insoleComponent.left.medial.value : -insoleComponent.left.lateral.value
                } else {
                    insoleParametersData.left.heelPost = {
                        extrinsic: insoleComponent.left.medial ? insoleComponent.left.medial.extrinsic : insoleComponent.left.lateral.extrinsic,
                        type: insoleComponent.left.type as HeelPostType,
                        angle: insoleComponent.left.medial ? insoleComponent.left.medial.value : -insoleComponent.left.lateral.value
                    }
                }

            }

            // Right foot
            if (insoleComponent.footSelection === "right" || insoleComponent.footSelection === "both") {

                if (insoleParametersData.right.heelPost) {
                    insoleParametersData.right.heelPost.angle = insoleComponent.right.medial ? insoleComponent.right.medial.value : -insoleComponent.right.lateral.value
                } else {
                    insoleParametersData.right.heelPost = {
                        extrinsic: insoleComponent.right.medial ? insoleComponent.right.medial.extrinsic : insoleComponent.right.lateral.extrinsic,
                        type: insoleComponent.right.type as HeelPostType,
                        angle: insoleComponent.right.medial ? insoleComponent.right.medial.value : -insoleComponent.right.lateral.value
                    }
                }

            }
        }
    })
    console.log("insoleParametersData: ", insoleParametersData)
    return insoleParametersData
}